import { LogIn, Mail } from 'lucide-preact'
import { api } from '../lib/api.ts'
import { Logo } from '../lib/icon.tsx'

const login = api['POST/api/login'].signal()

export function LoginPage() {
  const handleSubmit = async (e: Event) => {
    e.preventDefault()
    const form = e.target as HTMLFormElement
    const emailInput = form.email as HTMLInputElement
    await login.fetch({ email: emailInput.value })

    if (login.error) {
      emailInput.setCustomValidity(login.error.message)
      form.reportValidity()
    }
  }

  if (login.data?.email) {
    return (
      <div class='min-h-screen flex items-center justify-center p-4'>
        <div class='w-full max-w-md bg-base-100 border border-base-300 p-8 rounded-box text-center'>
          <div class='flex justify-center mb-6'>
            <div class='w-16 h-16 bg-primary rounded-full flex items-center justify-center'>
              <Mail class='text-white' size='32' />
            </div>
          </div>

          <h2 class='text-2xl font-bold mb-2'>Check Your Email</h2>
          <p class='text-base-content/60 text-sm mb-6'>
            We've sent a login link to confirm your identity
          </p>

          <div class='bg-base-200 rounded-box p-4 mb-6'>
            <p class='text-sm text-base-content/70 mb-2'>Sent to:</p>
            <p class='font-mono text-primary font-semibold break-all'>
              {login.data?.email}
            </p>
          </div>

          <p class='text-xs text-base-content/70 mb-6'>
            Click the link in the email to sign in. The link is valid for 30
            minutes.
          </p>

          <button
            type='button'
            onClick={login.reset}
            class='btn btn-outline btn-sm w-full'
          >
            Use a different email
          </button>
        </div>
      </div>
    )
  }

  return (
    <div class='h-[80vh] flex items-center justify-center p-4'>
      <div class='w-full max-w-md'>
        <div class='text-center mb-8'>
          <h1 class='text-3xl font-bold mb-2'>
            Welcome to <span class='text-primary'>License Hub</span>
          </h1>
        </div>

        <div class='bg-base-100 border border-base-300 p-8'>
          <form onSubmit={handleSubmit} class='space-y-4'>
            <div>
              <label class='block text-sm font-medium mb-2'>
                Email Address
              </label>
              <input
                type='email'
                name='email'
                onInput={(e) =>
                  (e.target as HTMLInputElement).setCustomValidity('')}
                placeholder='email@example.com'
                class='input input-bordered w-full'
                required
              />
            </div>

            <button
              type='submit'
              class='btn btn-primary w-full'
              disabled={Boolean(login.pending)}
            >
              {login.pending
                ? (
                  <>
                    <span class='loading loading-spinner loading-sm' />
                    Sending Link...
                  </>
                )
                : (
                  <>
                    Sign In
                    <LogIn size='18' />
                  </>
                )}
            </button>
          </form>

          <div class='divider my-6 text-xs text-base-content/50'>OR</div>

          <form action='/api/auth/google/login' method='get'>
            <button
              type='submit'
              class='btn btn-soft w-full'
              disabled={Boolean(login.pending)}
            >
              <Logo size={18} primary='currentColor' secondary='currentColor' />
              Login With SSO
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
